export const RECOMMENDED_PRINT_POSITION_FLOW_ACTIVE = true;
